import type { BillingType } from "~/models/DealBilling";

const paths = {
	index: `${process.env.NEXT_PUBLIC_API_HOST}/api/deals/:deal_id/deal_settlement_files?billing_type=:billing_type`
};

export const getDownloadPath = (
	dealId: string,
	billingType: BillingType
): string =>
	paths.index.replace(":deal_id", dealId).replace(":billing_type", billingType);
